<h5 class="title">Trending Topics</h5>
<div class="topics">
  <a class="topic" *ngFor="let topic of topicsArray">
    {{ topic }}
  </a>
</div>
